import React, { useState } from 'react';
import { QuickVisitModal } from '../visits/QuickVisitModal';
import { TaskList } from './TaskList';
import type { AgentGroup, PendingFollowup } from './types';

interface TodosResultsProps {
  loading: boolean;
  visible: PendingFollowup[];
  totalLoaded: number;
  searchActive: boolean;
  agentName: string | null;
  groups: AgentGroup[] | null;
  onOpenPos: (posId: string) => void;
  onFullVisit: (followup: PendingFollowup) => void;
  onRefresh: () => void;
}

export function TodosResults({
  loading,
  visible,
  totalLoaded,
  searchActive,
  agentName,
  groups,
  onOpenPos,
  onFullVisit,
  onRefresh,
}: TodosResultsProps) {
  const [showQuickVisit, setShowQuickVisit] = useState(false);
  const [selected, setSelected] = useState<PendingFollowup | null>(null);

  return (
    <>
      <TaskList
        loading={loading}
        visible={visible}
        totalLoaded={totalLoaded}
        searchActive={searchActive}
        agentName={agentName}
        groups={groups}
        onOpenPos={onOpenPos}
        onQuickVisit={(f) => {
          setSelected(f);
          setShowQuickVisit(true);
        }}
        onFullVisit={onFullVisit}
      />
      {selected && (
        <QuickVisitModal
          isOpen={showQuickVisit}
          onClose={() => {
            setShowQuickVisit(false);
            setSelected(null);
          }}
          followup={selected}
          onComplete={() => {
            setShowQuickVisit(false);
            setSelected(null);
            onRefresh();
          }}
        />
      )}
    </>
  );
}
